<form class="ui form" #form="ngForm" [class.loading]="isLoading">
    <div class="ui segment participants">
        <app-segment-header title="Will the review subject be participating in this review?"></app-segment-header>

        <mat-checkbox
            (change)="trackSelectingOfReviewSubjectToParticipate($event)"
            [ngModel]="participants.get(subject?.id)"
            (ngModelChange)="participants.set(subject?.id, $event)"
            name="subject"
            ><app-avatar *ngIf="subject" [employee]="subject" [name]="true"></app-avatar
        ></mat-checkbox>
    </div>

    <!-- Managers -->
    <div class="ui segment">
        <app-segment-header title="Select participants who manage this employee">
            <div *ngIf="managers.length" class="buttons">
                <ui-button type="link" (click)="selectAll(managers)">Select All</ui-button>
                <ui-button type="link" (click)="deselectAll(managers)">Deselect All</ui-button>
            </div>
        </app-segment-header>

        <div class="employee-list">
            <mat-checkbox
                (change)="trackSelectingOfParticipantsWhoManageEmployee($event)"
                *ngFor="let employee of managers; let i = index"
                [name]="'managers' + i"
                [ngModel]="participants.get(employee.id)"
                (ngModelChange)="participants.set(employee.id, $event)"
                ><app-avatar [employee]="employee" [name]="true"></app-avatar
            ></mat-checkbox>
        </div>

        <div *ngIf="!managers.length">
            {{ subject?.firstName }} {{ subject?.lastName }} does not appear to have any
            <strong>managers</strong>
        </div>
    </div>

    <!-- Direct Reports -->
    <div class="ui segment">
        <app-segment-header title="Select participants who are direct reports">
            <div *ngIf="directReports.length" class="buttons">
                <ui-button type="link" (click)="selectAll(directReports)">Select All</ui-button>
                <ui-button type="link" (click)="deselectAll(directReports)">Deselect All</ui-button>
            </div>
        </app-segment-header>

        <div class="employee-list">
            <mat-checkbox
                (change)="trackSelectingOfParticipantsWhoHaveDirectReports($event)"
                *ngFor="let employee of directReports; let i = index"
                [name]="'directReports' + i"
                [ngModel]="participants.get(employee.id)"
                (ngModelChange)="participants.set(employee.id, $event)"
                ><app-avatar [employee]="employee" [name]="true"></app-avatar
            ></mat-checkbox>
        </div>

        <div *ngIf="!directReports.length">
            {{ subject?.firstName }} {{ subject?.lastName }} does not appear to have any
            <strong>direct reports</strong>
        </div>
    </div>

    <!-- Peers -->
    <div class="ui segment">
        <app-segment-header title="Select participants who are peers">
            <div *ngIf="peers.length" class="buttons">
                <ui-button type="link" (click)="selectAll(peers)">Select All</ui-button>
                <ui-button type="link" (click)="deselectAll(peers)">Deselect All</ui-button>
            </div>
        </app-segment-header>

        <div class="employee-list">
            <mat-checkbox
                (change)="trackSelectingOfPeersAsParticipants($event)"
                *ngFor="let employee of peers; let i = index"
                [name]="'peers' + i"
                [ngModel]="participants.get(employee.id)"
                (ngModelChange)="participants.set(employee.id, $event)"
                ><app-avatar [employee]="employee" [name]="true"></app-avatar
            ></mat-checkbox>
        </div>

        <div *ngIf="!peers.length">
            {{ subject?.firstName }} {{ subject?.lastName }} does not appear to have any
            <strong>peers</strong>
        </div>
    </div>
</form>
